
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { CompanyAccountPlan, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class CompanyAccountPlanEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    companyAccountPlan: CompanyAccountPlan;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getCompanyAccountPlan()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getCompanyAccountPlan(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.companyAccountPlan = data;
                this.onDataChanged.next(this.companyAccountPlan);
                resolve(this.companyAccountPlan);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('companyAccountPlan/' + this.routeParams.id).subscribe((res: CompanyAccountPlan ) => {
                    this.companyAccountPlan = res;
                    this.onDataChanged.next(this.companyAccountPlan);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(companyAccountPlan): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('companyAccountPlan/', companyAccountPlan).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(companyAccountPlan): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('companyAccountPlan/', companyAccountPlan).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(companyAccountPlan): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('companyAccountPlan/' + companyAccountPlan.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): CompanyAccountPlan {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
